const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
};

const showNotification = (message: string, title: string = '') => {
    if (!('Notification' in window)) {
        console.info('This browser does not support desktop notification');
        return;
    }

    requestNotificationPermission().then((granted) => {
        if (granted) {
            const options = {
                body: message
            }

            new Notification(title, options);
        } else {
            console.info('Notification permission denied');
        }
    });
};

export { showNotification };
